import { render, staticRenderFns } from "./listCompany.vue?vue&type=template&id=b27c531c&scoped=true&"
import script from "./listCompany.vue?vue&type=script&lang=js&"
export * from "./listCompany.vue?vue&type=script&lang=js&"
import style0 from "./listCompany.vue?vue&type=style&index=0&id=b27c531c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27c531c",
  null
  
)

export default component.exports